/**
 * The chart width in pixels, kept out of `trend.actions` so modules the dispatch layer loads (like
 * the series runtime helpers) can read it without importing the fetch orchestration and the module
 * cycles that come with it. `trend.actions` computes and records the value: at its module load and
 * whenever the window grows past a threshold.
 */

let chartWidth: number | undefined = process.env.NODE_ENV === 'test' ? 1 : undefined;

/** The chart width in pixels; `trend.actions` records it before any data fetch can read it */
export function getChartWidth(): number {
  if (chartWidth === undefined) {
    throw new Error('Expected the chart width to be set via recordChartWidth()');
  }

  return chartWidth;
}

/** Records the width `setChartWidth` computed; the fetch orchestration stays in `trend.actions` */
export function recordChartWidth(newChartWidth: number): void {
  chartWidth = newChartWidth;
}
